import useAuthUser from "@/hooks/useAuthUser";
import { avatarColor } from "@/utils/call-center.utils";
import SmsCompactConversation from "./sms-compact-conversation";
import SmsQuickSend from "./sms-quick-send";
import { useSmsConversation } from "./use-sms-conversation";

type Props = {
  lead: { id: number; name: string; avatar?: string | null };
};

/** The lead's text history and a one-line send box, sized for the call popup. */
const CallMessagesPanel = ({ lead }: Props) => {
  const { user } = useAuthUser();
  const { messages, total, loading, loadingMore, loadMore } = useSmsConversation(lead.id);
  const firstName = lead.name.trim().split(/\s+/)[0] ?? "";
  const userName = `${user.firstName} ${user.lastName}`.trim();

  return (
    <div>
      {loading ? (
        <div className="py-4 text-center text-[11.5px] italic text-slate-500">Loading texts…</div>
      ) : (
        <SmsCompactConversation
          messages={messages}
          lead={{ name: lead.name, color: avatarColor(lead.name), avatar: lead.avatar }}
          me={{ name: userName, color: "#3B82F6" }}
          total={total}
          loadingMore={loadingMore}
          onLoadMore={loadMore}
          emptyText={`No texts with ${firstName} yet.`}
        />
      )}
      <SmsQuickSend leadId={lead.id} firstName={firstName} />
    </div>
  );
};

export default CallMessagesPanel;
